/**
 * Build a flag image URL for an ISO 3166-1 alpha-2 country code.
 * Uses flagcdn.com (open-source CDN). Returns an SVG URL.
 * E.g. "AT" → "https://flagcdn.com/at.svg"
 */
export function countryFlagUrl(code: string): string {
  return `https://flagcdn.com/${code.toLowerCase()}.svg`;
}
